import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SupportProjectAccessService } from '../components/support-projects/support-project-access.service';

/**
 * Guard that blocks Support Projects when the user lacks Projects/Tasks view access.
 */
export const supportProjectModuleGuard: CanActivateFn = () => {
  const access = inject(SupportProjectAccessService);
  access.refresh();
  if (!access.canView()) {
    return inject(Router).createUrlTree(['/dashboard', 'home']);
  }
  return true;
};
